import { Injectable } from '@angular/core';
import { ActiveCartService } from '@cart/data-access';
import { CityService } from '@city/feature';
import { Pos } from '@shop/const';
import { ShopListFacade } from '@shop/data-access';
import { combineLatest, distinctUntilChanged, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShopListService {
  shops$ = this.shopListFacade.getShopList();
  shopsState$ = this.shopListFacade.getShopListState();
  loading$ = this.shopListFacade.getShopListLoading();
  noPosAvailable$ = this.shopListFacade.getNoPosAvailable();

  constructor(
    private shopListFacade: ShopListFacade,
    private cityService: CityService,
    private activeCartService: ActiveCartService,
  ) {}

  loadShopList(): void {
    this.shopListFacade.loadShopList();
  }

  getShop(id?: string): Observable<Pos> {
    return this.shopListFacade.getShop(id);
  }

  getContextUpdate(): Observable<void> {
    return combineLatest({
      activeBaseStoreCode: this.cityService.activeBaseStoreCode$,
      activeCartId: this.activeCartService.getActiveCartId(),
      entries: this.activeCartService.getEntries(),
    }).pipe(
      distinctUntilChanged(
        (a, b) =>
          a.activeBaseStoreCode === b.activeBaseStoreCode &&
          a.activeCartId === b.activeCartId &&
          JSON.stringify(a.entries) === JSON.stringify(b.entries),
      ),
      map(() => void 0),
    );
  }
}
